import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useGetProfile = options => {
  return useQuery({
    ...options,
    queryKey: [QUERY_KEYS.user.profile],
    queryFn: () =>
      userService.profile().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }

        throw new Error('Fetch failed');
      }),
  });
};
